module.exports = __webpack_public_path__ + "img/qy8.ecc207ce.png";